module.exports = __webpack_public_path__ + "static/media/PingFangHK Semibold-01.b241499d.svg";